import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent, { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import { Stack } from '@mui/material';
import _ from 'lodash';
import MedicalDocumentBrief from './MedicalDocumentBrief';
import moment from "moment";

const MedicalDocumentsTimeline = ({ containerRef, medicalDocuments }) => {
  const medicalDocumentsGroupedByDate = _(medicalDocuments).groupBy('date').map((medicalDocuments, date) => ({ date, medicalDocuments })).value();

  return (
    <Stack sx={{ maxHeight: "100%", overflow: "auto" }}>
    <Timeline
      sx={{
        [`& .${timelineOppositeContentClasses.root}`]: {
          flex: { xs: 0.5, md: 0.3, lg: 0.3, xl: 0.1 }
        }
      }}
      ref={containerRef}
      >
      {
        _.map(medicalDocumentsGroupedByDate, ({ date, medicalDocuments }) =>
          _.map(medicalDocuments, (medicalDocument, index) => (
            <TimelineItem key={medicalDocument.id}>
              <TimelineOppositeContent
                sx={{ m: 'auto 0', height: "100%", pt: 3 }}
                align="right"
                variant="body2"
                color="text.secondary"
              >  
                {index == 0 && moment(date).format("DD/MM/YYYY")}  
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <MedicalDocumentBrief medicalDocument={medicalDocument} />
              </TimelineContent>
            </TimelineItem>
          ))
        )
      }
    </Timeline>
  </Stack>
  );
};

export default MedicalDocumentsTimeline;